export const InstagramLink = "https://www.instagram.com/koruacne/?igshid=OGQ5ZDc2ODk2ZA%3D%3D";
export const FacebookLink = " https://www.facebook.com/people/Koru/61551062338329/";
export const TiktokLink = "https://www.tiktok.com/@koruacne?_t=8fqgCMpu71N&_r=1"
export const AppleLink = "https://apps.apple.com/app/koru-your-acne-coach/id6466275209"
export const AndroidLink = "https://play.google.com/store/apps/details?id=com.koruacne.app"
export const AndroidLink2 = "market://details?id=com.koruacne.app"